// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__Feie8","sm":"mimic___styles_sm__o14mi","outline":"mimic___styles_outline__jHvhl","md":"mimic___styles_md__fKT70","lg":"mimic___styles_lg__Tchyz"};